import RequestAPI from '../index'
import getConfig from 'Config/config'

const apiServer = new RequestAPI(getConfig().getApiServer)
export const apiMockupServer = new RequestAPI(getConfig().getApiMockupServer)
export default apiServer
